import { openComponentInPopup } from "./common";

export default class StockDetailsPopupLink {
    private componentName = 'AllVariantsStockAvailability';

    constructor(baseElement: HTMLElement) {
        baseElement.addEventListener('click', (evt) => this.openPopup(evt))
    }


    private async openPopup(evt: Event): Promise<void> {
        evt.preventDefault();
        await openComponentInPopup(this.componentName, null, null, true);
    }
}
